import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import get from "lodash/get";
import map from "lodash/map";
import logoImage from "../../static/images/sochIOtLogo.jpeg";
import dayjs from "dayjs";
import {fetchImageAsBase64} from "../images";
import {checkNullable} from '../../utilities/helpers';

const printLabel = (doc, value, x, y) => {
  doc.setTextColor(0, 0, 0);
  doc.text(value, x, y, { angle: 90 });
};

const printValue = (doc, value, x, y) => {
  doc.setTextColor(0, 0, 0);
  doc.setFont('helvetica',"bold");
  doc.text(value, x, y, { angle: 90 });
};

const companyDetails = (selectedTemplate, filter) => [
  {
    key: "Machine",
    value: get(selectedTemplate, "template.name"),
    suffix: 1.5,
    label: 1,
  },
  {
    key: "Company",
    value: get(filter, "company.name"),
    suffix: 1.5,
    label: 1,
  },
  {
    key: "Address",
    value: get(filter, "company.address"),
    suffix: 2,
    label: 1,
  },
];

const statsDetails = (selectedTemplate) => [
  {
    key: "Date",
    value: `${dayjs(get(selectedTemplate, "date.0"), "YYYY-MM-DD").format(
      "DD/MM/YYYY"
    )}-${dayjs(get(selectedTemplate, "date.1"), "YYYY-MM-DD").format(
      "DD/MM/YYYY"
    )}`,
    label: 1,
    suffix: 1.5,
  },
  {
    key: "Machine Efficency",
    value: `${checkNullable(
      get(selectedTemplate, "meta.machine_efficiency", 0)
    )}%`,
    label: 1.5,
    suffix: 1.2,
  },
  {
    key: "Quality Ratio",
    value: `${checkNullable(get(selectedTemplate, "meta.quality_ratio", 0))}%`,
    label: 1.2,
    suffix: 1,
  },
];

const renderStatsRow = (doc, statsDetails, yOffset, xOffset) => {
  map(statsDetails, (arr, i) => {
    printLabel(doc, `${get(arr, "key")} : `, xOffset, yOffset);
    yOffset = yOffset - 20 * get(arr, "label");
    printValue(doc, get(arr, "value"), xOffset, yOffset);
    yOffset = yOffset - 30 * get(arr, "suffix");
  });
};

export const generateInjectionMouldingDayGraphPdf = async (
  selectedTemplate,
  filter,
  setLoading,
  fileName
) => {
  try {
    setLoading(true);
    const doc = new jsPDF({ format: "a4",compress:true });
    doc.setFontSize(8);
    doc.setTextColor(0, 0, 0);
    doc.setFont("helvetica", "normal");
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    // Define section widths
    const firstSectionWidth = pageWidth * 0.2; // 20% of the width
    const secondSectionWidth = pageWidth * 0.8; // 80% of the width

    let yOffset = 2;
    let xOffset = 2;
    const logoWidth = firstSectionWidth - 10;
    const logoHeight = logoWidth * 0.6;

    if (get(filter, "company.logo.key")) {
      doc.addImage(logoImage, "PNG", xOffset, yOffset, logoWidth, logoHeight);
      yOffset += logoHeight;
      let logoBase64 = await fetchImageAsBase64(
        get(filter, "company.logo.key")
      );

      doc.addImage(logoBase64, "PNG", xOffset, yOffset, logoWidth, logoHeight);
    } else {
      doc.addImage(logoImage, "PNG", xOffset, yOffset, logoWidth, logoHeight);
    }

    // Render statistics
    yOffset = pageHeight - 10;
    renderStatsRow(doc, companyDetails(selectedTemplate, filter), yOffset, 8);
    renderStatsRow(doc, statsDetails(selectedTemplate, filter), yOffset, 18);

    // Fetch graphs
    const graphContainers = document.querySelectorAll(".graph-container");
    const totalGraphs = graphContainers.length;

    yOffset = 10;
    const availableHeight = pageHeight - 2; // Leave space for header/footer
    const graphWidth = secondSectionWidth - 5;
    const graphHeight = availableHeight / totalGraphs - 5; // Divide space equally

    for (let i = 0; i < totalGraphs; i++) {
      const graphContainer = graphContainers[i];
      const graphCanvas = await html2canvas(graphContainer);
      const graphImgData = graphCanvas.toDataURL("image/png");

      const scaledGraphHeight = Math.min(
        (graphCanvas.height * graphWidth) / graphCanvas.width,
        graphHeight
      );

      doc.addImage(
        graphImgData,
        "PNG",
        firstSectionWidth,
        yOffset,
        graphWidth,
        scaledGraphHeight
      );

      yOffset += scaledGraphHeight + 2; // Reduce spacing
    }

    doc.save(`${fileName}`);
  } catch (error) {
    console.error("Error generating PDF:", error);
  } finally {
    setLoading(false);
  }
};